import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AbstractHttpService } from "./http-abstract-service";
import { SubmitData } from "../dto";

@Injectable({
    providedIn: "root",
})
export class HttpFacetecService extends AbstractHttpService {
    constructor(http: HttpClient) {
        super(http, "");
    }

    public start(ref: string) {
        const path = `/auth/${ref}`;
		return super.get(path);
    }

    public submit(data: SubmitData) {
        const path = `/customer/submit`;
        return super.post(path, data);
    }

    public getUsers() {
        const path = `/admin/getAll`;
        return super.get(path);
    }
}
